import { LocationsActionTypes } from './constants';

type LocationsAction = { type: string, payload: {} | string };

export const locationsApiResponseSuccess = (actionType: string, data: any): LocationsAction => ({
    type: LocationsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const locationsApiResponseError = (actionType: string, error: string): LocationsAction => ({
    type: LocationsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const locationsGetAllLocations = (query: string): LocationsAction => ({
    type: LocationsActionTypes.READ_ALL_LOCATIONS_REQUEST,
    payload: { query },
});

export const locationsCreateLocation = (location: any, callback): LocationsAction => ({
    type: LocationsActionTypes.CREATE_LOCATION_REQUEST,
    payload: { location, callback },
});

export const locationsUpdateLocation = (locationId, location: any): LocationsAction => ({
    type: LocationsActionTypes.UPDATE_LOCATION_REQUEST,
    payload: { locationId, location },
});

export const locationsDeleteLocation = (locationId): LocationsAction => ({
    type: LocationsActionTypes.DELETE_LOCATION_REQUEST,
    payload: { locationId },
});

export const locationsResetLocation = (): LocationsAction => ({
    type: LocationsActionTypes.RESET_STATE,
    payload: {},
});

export const locationsResetAllErrors = (): LocationsAction => ({
    type: LocationsActionTypes.RESET_ALL_ERRORS,
    payload: {},
});
